function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { BoxChecked, BoxEmpty } from 'pcln-icons';
import PropTypes from 'prop-types';
import { applyVariations, getPaletteColor, deprecatedColorValue } from '../utils';
var Checkbox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // eslint-disable-next-line react/prop-types
  var disabled = props.disabled,
      size = props.size; // Add 4px to Icon's height and width to account for size reduction caused by adding padding to SVG element

  var borderAdjustedSize = size + 4;
  return /*#__PURE__*/React.createElement(CheckBoxWrapper // eslint-disable-next-line react/prop-types
  , {
    theme: props.theme,
    color: props.color,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(StyledInput, _extends({
    type: "checkbox"
  }, props, {
    role: "checkbox",
    ref: ref
  })), /*#__PURE__*/React.createElement(BoxChecked, {
    size: borderAdjustedSize,
    "data-name": "checked"
  }), /*#__PURE__*/React.createElement(BoxEmpty, {
    size: borderAdjustedSize,
    "data-name": "empty"
  }));
});
var CheckBoxWrapper = styled.div.withConfig({
  displayName: "Checkbox__CheckBoxWrapper",
  componentId: "sc-kbsfv7-0"
})(["display:inline-flex;align-items:center;position:relative;vertical-align:middle;padding:2px;cursor:", ";background-color:inherit;color:", ";svg{border:1px solid transparent;border-radius:4px;padding:2px;}svg[data-name='checked']{display:none;}> input:hover ~ svg[data-name='empty']{color:", ";}> input{&:focus ~ svg{border:1px solid ", ";background-color:", ";}}> input:checked{& ~ svg[data-name='checked']{display:inline-block;color:", ";}& ~ svg[data-name='empty']{display:none;}&:focus ~ svg{border:1px solid ", ";background-color:", ";}&:hover ~ svg[data-name='checked']{color:", "}", ""], function (props) {
  return props.disabled ? "default" : "pointer";
}, function (props) {
  return props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('border.dark')(props);
}, function (props) {
  return props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('base')(props);
}, getPaletteColor('border.base'), getPaletteColor('background.light'), function (props) {
  return props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('base')(props);
}, getPaletteColor('base'), getPaletteColor('light'), function (props) {
  return props.disabled ? getPaletteColor('border.base')(props) : getPaletteColor('dark')(props);
}, applyVariations('Checkbox'));
var StyledInput = styled.input.withConfig({
  displayName: "Checkbox__StyledInput",
  componentId: "sc-kbsfv7-1"
})(["appearance:none;opacity:0;position:absolute;z-index:0;"]);
Checkbox.displayName = 'Checkbox';
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.number,
  onChange: PropTypes.func,
  color: deprecatedColorValue()
};
Checkbox.defaultProps = {
  size: 20,
  color: 'primary'
};
export default withTheme(Checkbox);